import { IOpenCenteredModal } from "./interface";

export const constantOpenModalFailed = {
  open: false,
  onClose: () => {},
  title: `Common:error`,
  destination: `Common:error_detail`,
};

export const constantConfigMaintenance = {
  open: false,
  title: "",
  description: "",
};

export const constantModal: IOpenCenteredModal = {
  type: "loading",
  open: false,
  title: "",
  description: "",
  onClose: () => {},
  onOk: () => {},
};
